import stockService from 'common/services/stockService'
import redInfoModule from '../redInfoModule'

function replaceSpecialChar(source) {
    return source.replace(new RegExp(/(\r)/g), '\\r').replace(new RegExp(/(\n)/g), '\\n')
}

/**
 * 红字信息表上传回写
 * @param  {object} da 控制台接口返回
 * @return {Promise}   promise
 */
function uploadBack(da) {
    const {
        httpRequest,
        $q
    } = this
    const defered = $q.defer()
    const {
        promise
    } = defered
    let ENCMSG = da.value
    if (da.retcode === -1) {
        defered.reject(da.retmsg)
        return promise
    }
    ENCMSG = replaceSpecialChar(ENCMSG)
    const result = $.parseJSON(ENCMSG)
    if (result.retcode === '0') {
        let responseMsg = $.parseXML(result.responseMsg)
        responseMsg = $(responseMsg).find('FPXT_COM_OUTPUT DATA').text()
        httpRequest.post_base64DeCode({
            codeType: 'decode',
            invData: responseMsg,
        }).then((res) => {
            if (!res.data.success) {
                defered.reject(res.data.message)
                return
            }
            responseMsg = $.parseXML(res.data.value)
            const code = $(responseMsg).find('OUTPUT CODE').text()
            // code=="0000"表示上传成功
            if (code === '0000') {
                // BEGIN:add  by  wxb for [红字信息表返回解析] on 2018-04-08
                const redInvReqList = $(responseMsg).find('OUTPUT RedInvReqBill')
                const postData = []
                for (let i = 0; i < redInvReqList.length; i++) {
                    const tempData = {}
                    tempData.infoSerialNo = redInvReqList.eq(i).find('ReqBillNo').text()
                    tempData.infoCode = redInvReqList.eq(i).find('ResBillNo').text()
                    tempData.infoStatus = redInvReqList.eq(i).find('StatusDM').text()
                    tempData.statusDescribe = redInvReqList.eq(i).find('StatusMC').text()
                    postData[i] = tempData
                }
                // END
                // 批量上传后回写
                httpRequest.post_updateRedInfoStatus(postData).then((res2) => {
                    if (!res2.data.success) {
                        defered.reject(res2.data.message)
                        return
                    }
                    defered.resolve('上传回写成功！')
                }, (err) => {
                    defered.reject(err.data.message)
                })
                // }
            } else {
                defered.reject(`红票上传失败:${$(responseMsg).find('OUTPUT MESS').text()}`)
            }
        }, (err) => {
            defered.reject(err.data.message)
        })
    } else {
        defered.reject(`调用组件接口红票上传失败：${result.retmsg}`)
    }
    return promise
}

/**
 * 红字信息表下载回写
 * @param  {object} data      控制条返回数据
 * @param  {string} serverNum 对应金税盘信息mechineNo
 * @param  {string} Kpfwqh    开票机号
 * @return {Promise}          promise
 */
function downloadBack(data, serverNum, Kpfwqh) {
    const {
        httpRequest,
        $q,
        $filter
    } = this
    const defered = $q.defer()
    const {
        promise
    } = defered
    const nowDateStr = ($filter('date')(new Date(), 'yyyy-MM-dd'))
    const downloadResult = {
        total: 0,
        list: [],
    }
    let ENCMSG = data.value
    ENCMSG = replaceSpecialChar(ENCMSG)
    const SIDParam = $.parseJSON(ENCMSG)
    if (SIDParam.retcode === '0') {
        let responseMsg = $.parseXML(SIDParam.responseMsg)
        responseMsg = $(responseMsg).find('FPXT_COM_OUTPUT DATA').text()
        if (responseMsg == null || responseMsg === '') {
            defered.reject('下载信息获取失败!')
            return promise
        }
        httpRequest.post_base64DeCode({
            codeType: 'decode',
            invData: responseMsg,
        }).then((res) => {
            responseMsg = $.parseXML(res.data.value)
            const $responseMsg = $(responseMsg)
            const code = $responseMsg.find('OUTPUT CODE').text()
            if (code === '0000') {
                const redBillArry = []
                downloadResult.total = Number($responseMsg.find('ALLCOUNT').text())
                $responseMsg.find('DATA RedInvReqBill').each(function each1() {
                    const ReqBillNo = $(this).find('ReqBillNo').text() // 对应INPUT中的ReqBillNo
                    const ResBillNo = $(this).find('ResBillNo').text() // 信息表编号
                    const StatusDM = $(this).find('StatusDM').text() // 信息表状态代码
                    const StatusMC = $(this).find('StatusMC').text() // 信息表状态描述
                    const BillType = $(this).find('BillType').text() // 信息表类型 0：正常，1：逾期
                    const TypeCode = $(this).find('TypeCode').text() // 对应蓝票代码
                    const InvNo = $(this).find('InvNo').text() // 对应蓝票号码
                    const Szlb = $(this).find('Szlb').text() // 税种类别，0 营业税，1 增值税
                    const BuyerName = $(this).find('BuyerName').text() // 购方名称
                    const BuyTaxCode = $(this).find('BuyTaxCode').text() // 购方税号
                    const SellerName = $(this).find('SellerName').text() // 销方名称
                    const SellTaxCode = $(this).find('SellTaxCode').text() // 销方税号
                    const Amount = $(this).find('Amount').text() // 合计金额
                    const TaxRate = $(this).find('TaxRate').text() // 税率，多税率时为空
                    const Tax = $(this).find('Tax').text() // 合计税额
                    const infoDate = $(this).find('Date').text() // 填开日期
                    let adValoremTotal
                    if (Amount && TaxRate) {
                        adValoremTotal = new window.BigDecimal(Amount).add(new window.BigDecimal(Tax)).toString()
                    }
                    const ReqMemo = $(this).find('ReqMemo').text() // 十位数字表示的申请说明
                    const redBillLine = []
                    $(this).find('RedInvReqBillMx GoodsMx').each(function each2(index) {
                        const serial = index + 1
                        const GoodsName = $(this).find('GoodsName').text() // 商品名称
                        const GoodsUnit = $(this).find('GoodsUnit').text() // 商品单位
                        const GoodsPrice = $(this).find('GoodsPrice').text() // 商品单价
                        const GoodsTaxRate = $(this).find('GoodsTaxRate').text() // 税率
                        const GoodsGgxh = $(this).find('GoodsGgxh').text() // 规格型号
                        const GoodsNum = $(this).find('GoodsNum').text() // 数量
                        const GoodsJE = $(this).find('GoodsJE').text() // 金额
                        const GoodsSE = $(this).find('GoodsSE').text() // 税额
                        const HS_BZ = $(this).find('HS_BZ').text() === 'N' ? '0' : '1' // <!--含税标志 N：不含税，Y:含税-->
                        const SPBM = $(this).find('SPBM').text() // 商品编码
                        const QYSPBM = $(this).find('QYSPBM').text() // 企业商品编码
                        const SYYHZCBZ = $(this).find('SYYHZCBZ').text() // 是否使用优惠政策标识 0：不使用，1：使用
                        const YHZC = $(this).find('YHZC').text() // 优惠政策名字
                        const LSLBZ = $(this).find('LSLBZ').text() // 零税率标识
                        const redLine = {
                            serialNo: serial,
                            matName: GoodsName,
                            unit: GoodsUnit,
                            price: GoodsPrice,
                            taxRate: GoodsTaxRate,
                            spec: GoodsGgxh,
                            quantity: GoodsNum,
                            amount: GoodsJE,
                            taxAmount: GoodsSE,
                            invType: '0',
                            isTax: HS_BZ,
                            revenueCode: SPBM,
                            ownCoding: QYSPBM,
                            lineNature: '0',
                            isPrivilege: SYYHZCBZ,
                            privilegeType: YHZC,
                            zeroTax: LSLBZ,
                        }
                        redBillLine.push(redLine)
                    })

                    const redBill = {
                        serverNo: serverNum,
                        ukeyNo: Kpfwqh,
                        infoSerialNo: ReqBillNo,
                        infoNumber: ReqBillNo,
                        infoCode: ResBillNo,
                        infoStatus: StatusDM,
                        applyFormFlag: BillType,
                        blueInvoiceCode: TypeCode,
                        blueInvoiceNumber: InvNo,
                        businessTaxFlag: Szlb,
                        // applyDate: nowDateStr,
                        custName: BuyerName,
                        custCreditCode: BuyTaxCode,
                        saleName: SellerName,
                        saleCreditCode: SellTaxCode,
                        totalAmt: Amount,
                        totalTaxamt: Tax,
                        adValoremTotal,
                        taxRate: TaxRate,
                        applyReason: ReqMemo,
                        invType: '0',
                        detailFlag: '0',
                        statusFlag: '1',
                        infoSourceFlag: '0',
                        ovatRedDetailDTOList: redBillLine,
                        infoStatusOnPage: StatusMC, // 页面展示使用
                        infoId: redBillArry.length + 1,
                        statusDescribe: StatusMC,
                        infoDate,
                    }
                    redBillArry.push(redBill)
                })
                downloadResult.list = redBillArry
                defered.resolve(downloadResult)
            } else {
                defered.reject('红字信息表下载失败')
            }
        }, (err) => {
            defered.reject(err.data.message)
        })
    } else {
        defered.reject('金税盘信息获取失败!无法下载!')
        return promise
    }
    return promise
}
export default class RedInfoService {
    constructor(httpRequest, $q, $filter, invoiceOpenService) {
        this.httpRequest = httpRequest
        this.$q = $q
        this.$filter = $filter
        this.invoiceOpenService = invoiceOpenService
    }

    upload(infoIdList, ukeyId) {
        const {
            httpRequest,
            invoiceOpenService,
            $q
        } = this
        const uploadCallback = uploadBack.bind(this)
        const defered = $q.defer()
        const {
            promise
        } = defered
        if (!infoIdList || infoIdList.length === 0) {
            defered.reject('请先选择红字信息表行')
            return promise
        }
        const infoIds = infoIdList.join(',')
        if (invoiceOpenService.checkIsA9(ukeyId)) {
            const ukey = JSON.parse(localStorage.user_info).sysUkeyList.filter(u => {
                return u.ukeyId == ukeyId
            })
            httpRequest.post_uploadRedInfo({
                diskCode: ukey[0].diskCode,
                infoIdArray: infoIdList,
                mock: isMock
            }).then(() => {
                defered.resolve('上传成功')
            }, () => {
                defered.reject()
            })
        } else {
            stockService.getDiskInfo().then((diskInfoJSON) => {
                const diskNo = JSON.parse(diskInfoJSON).CheckCode
                httpRequest.post_getRedInfoForUploadParam({
                    infoIdArray: infoIds,
                    diskNo,
                }).then((res) => {
                    // 上传税局
                    window.top.TaxCore.tax.InvBatchUploadSub(res.data.value, (data) => {
                        defered.resolve(uploadCallback(data))
                    }, '', '', 0)
                }, (err) => {
                    defered.reject(err.data.message)
                })
            }, () => {
                defered.reject('获取金税盘信息失败')
            })
        }

        return promise
    }

    queryDownload(queryParam) {
        const {
            httpRequest,
            invoiceOpenService,
            $q
        } = this
        const defered = $q.defer()
        const {
            promise
        } = defered
        const downloadCallback = downloadBack.bind(this)
        if (invoiceOpenService.checkIsA9(queryParam.disk.ukeyId)) {
            httpRequest.post_downLoadRedInfo(queryParam).then(res=>{
                console.log(res.data.value)
                defered.resolve(res.data.value)
            },()=>{
                defered.reject()
            })
        } else {
            const writeInput = '<?xml version=\'1.0\' encoding=\'GBK\'?><FPXT_COM_INPUT><ID>0400</ID><DATA></DATA></FPXT_COM_INPUT>'
            window.top.TaxCore.tax.invInfo(writeInput, (data) => {
                const SIDParam = $.parseJSON(data.value)
                const creditCode = SIDParam.TaxCode
                const serverNum = SIDParam.MachineNo
                const machineNo = SIDParam.CheckCode
                const {
                    Kpfwqh
                } = SIDParam
                if (!creditCode || !serverNum || !machineNo) {
                    defered.reject('获取金税盘信息失败')
                    return
                }
                const bwInput = `<?xml version="1.0" encoding="GBK"?><FPXT><INPUT><NSRSBH>${creditCode}</NSRSBH><SBBH>${machineNo}</SBBH><KPJH>${serverNum}</KPJH><YQZT>N</YQZT><TKRQ_Q>${queryParam.invoiceDateMin}</TKRQ_Q><TKRQ_Z>${queryParam.invoiceDateMax}</TKRQ_Z><GFSH>${queryParam.custCreditCode}</GFSH><XFSH>${queryParam.saleCreditCode}</XFSH><XXBBH>${queryParam.infoCode}</XXBBH><XXBFW>${queryParam.invInfoFw}</XXBFW><PAGENO>${queryParam.pageNo}</PAGENO><PAGESIZE>${queryParam.pageSize}</PAGESIZE></INPUT></FPXT>`
                httpRequest.post_base64DeCode({
                    codeType: 'encode',
                    invData: bwInput,
                }).then((res) => {
                    const outerInput = `<?xml version="1.0" encoding="GBK"?><FPXT_COM_INPUT><ID>0201</ID><DATA>${res.data.value}</DATA></FPXT_COM_INPUT>`
                    window.top.TaxCore.tax.InvBatchUploadSub(outerInput, (data1) => {
                        defered.resolve(downloadCallback(data1, serverNum, Kpfwqh))
                    }, '', '', 0)
                })
            }, '', '', 0)
        }
        return promise
    }

    download(selectedRows) {
        return this.httpRequest.post_updateRedInfoForDownloads(selectedRows)
    }
    getCurrentDiskId() {
        const {
            $q
        } = this
        const defered = $q.defer()
        const {
            promise
        } = defered
        stockService.getDiskInfo().then((diskInfoJSON) => {
            const diskInfo = JSON.parse(diskInfoJSON)
            defered.resolve(diskInfo)
        }, () => {
            defered.reject('获取金税盘信息失败')
        })
        return promise
    }
}
RedInfoService.$inject = ['httpRequest', '$q', '$filter', 'invoiceOpenService']
redInfoModule.service('redInfoService', RedInfoService)


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/service/RedInfoService.js